import type { InquiryListParams } from '../inquiry.type.ts';

/**
 * Inquiry 도메인 Query Key 팩토리.
 *  all                → ['inquiry']
 *  lists              → ['inquiry', 'list']
 *  list(params)       → ['inquiry', 'list', { page, size, ... }]
 *  details            → ['inquiry', 'detail']
 *  detail(id)         → ['inquiry', 'detail', '17']
 */
export const inquiryKeys = {
  all: ['inquiry'] as const,
  lists: () => [...inquiryKeys.all, 'list'] as const,
  list: (params: InquiryListParams) =>
    [...inquiryKeys.lists(), params] as const,
  userMenuNotification: () =>
    [...inquiryKeys.all, 'user-menu-notification'] as const,
  details: () => [...inquiryKeys.all, 'detail'] as const,
  detail: (id: string | number) =>
    [...inquiryKeys.details(), String(id)] as const,
};
